import { JSONObject } from 'module/types/common';
import { CommandProps, Editor } from '@tiptap/core';
import { Transaction } from '@tiptap/pm/state';
import { getSliceFromJSON } from '../../../../utils/editor-utils';
import { AskAiSelectionHighlightAttributes } from '../../../aski-ai-selection-highlight/types';
import { addAskAiSelectionHighlight } from '../../../aski-ai-selection-highlight/utils';
import {
  getContentWithRetainedMeta,
  retainMetaForNode,
} from '../../utils/replace-content';
import { ContentReplacementOptions } from '../types';

export const replaceSelectionWithContent = (
  editor: Editor,
  tr: Transaction,
  content: JSONObject[],
  from: number,
  to: number,
  options: ContentReplacementOptions = {
    retainMetaForNode: retainMetaForNode,
  },
) => {
  const sliceToReplace = getSliceFromJSON(editor, content);
  const {
    content: finalContentToReplace,
    from: fromPositionForReplacement,
    to: toPositionForReplacement,
  } = getContentWithRetainedMeta(editor, sliceToReplace, from, to, options);

  tr.replaceRange(
    fromPositionForReplacement,
    toPositionForReplacement,
    finalContentToReplace,
  );
};
export const replaceSelectionWithContentCommand =
  (
    content: JSONObject[],
    from: number,
    to: number,
    options: ContentReplacementOptions = {},
  ) =>
  ({ editor, tr }: CommandProps) => {
    replaceSelectionWithContent(editor, tr, content, from, to, options);

    return true;
  };
export const addAskAiSelectionHighlightToReplacedContent = (
  editor: Editor,
  tr: Transaction,
  replacedContentFrom: number,
  replacedContentTo: number,
  attributes?: AskAiSelectionHighlightAttributes,
) => {
  const currentDocumentSize = tr.doc.nodeSize;
  const previousDocumentSize = tr.before.nodeSize;
  const differenceInSize = currentDocumentSize - previousDocumentSize;
  const updatedToPosition = replacedContentTo + differenceInSize;

  addAskAiSelectionHighlight(
    editor,
    tr,
    replacedContentFrom,
    updatedToPosition,
    attributes,
  );

  return {
    from: replacedContentFrom,
    to: updatedToPosition,
  };
};
export const addAskAiSelectionHighlightToReplacedContentCommand =
  (
    replacedContentFrom: number,
    replacedContentTo: number,
    attributes?: AskAiSelectionHighlightAttributes,
  ) =>
  ({ editor, tr }: CommandProps) => {
    addAskAiSelectionHighlightToReplacedContent(
      editor,
      tr,
      replacedContentFrom,
      replacedContentTo,
      attributes,
    );

    return true;
  };
